import { useState, useCallback } from 'react'

export const usePopupSwitcher = () => {
  const [currentPopup, setCurrentPopup] = useState(null)
  const [popupContext, setContext] = useState({})

  const openPopup = useCallback((popupName) => (context = {}) => {
    setContext(context)
    setCurrentPopup(popupName)
  }, [])
  const closePopup = useCallback(() => {
    setCurrentPopup(null)
    setContext({})
  }, [])
  const isPopupOpen = useCallback((popupName) => currentPopup === popupName, [currentPopup])

  return { openPopup, closePopup, isPopupOpen, popupContext }
}
